import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { FOOTER } from "@/constants/testIds";

const PHONE_DISPLAY = "(705) 796-4025";
const PHONE_HREF = "tel:+17057964025";

export default function Footer() {
  return (
    <footer data-testid={FOOTER.root} className="mt-24 bg-[var(--ink)] text-[var(--cream)]">
      <div className="container-x pt-20 pb-12">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <div className="display-xl">
              Got ceilings &amp; walls<br/>that need <span className="text-[var(--coral)]">love?</span>
            </div>
            <a href={PHONE_HREF} className="btn-coral mt-8"><Phone size={18}/> Call Mike for a free estimate</a>
          </div>

          <div className="lg:col-span-3">
            <div className="num-badge mb-4">VISIT</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-[var(--coral)] shrink-0"/> Proudly serving the Southern Georgian Bay region — specializing in local expert repair from Collingwood to Bluewater Beach.</li>
              <li className="flex items-center gap-2"><Phone size={16} className="text-[var(--coral)]"/> <a href="tel:+17057964025">(705) 796-4025</a></li>
              <li className="text-[#E8E1D2]/70 text-xs pt-1 italic">Speak directly to Mike.</li>
              <li className="text-[#E8E1D2]/60 text-xs pt-1">Mon – Sat · 7:00am – 7:00pm</li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="num-badge mb-4">SITE</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>

        <hr className="border-[#E8E1D2]/10 my-12"/>

        <p className="text-center text-[11px] text-[#E8E1D2]/50 italic mb-6 max-w-2xl mx-auto">
          Smooth Finish Drywall Repairs is owned and operated by Mike Miller Drywall — the same trusted local service, now with a new look.
        </p>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#E8E1D2]/60">
          <p>© {new Date().getFullYear()} Smooth Finish Drywall Repairs.</p>
          <p>Built in Wasaga Beach, ON.</p>
        </div>
      </div>
    </footer>
  );
}
